JSONEditor.defaults.iconlibs.kendoui = JSONEditor.AbstractIconLib.extend({
  mapping: {
    collapse: 'triangle-1-s',
    expand: 'triangle-1-e',
    "delete": 'trash',
    edit: 'pencil',
    add: 'plusthick',
    cancel: 'closethick',
    save: 'disk',
    moveup: 'arrowthick-1-n',
    movedown: 'arrowthick-1-s',
    clear: 'circle-close',
    time: 'time',
    calendar: 'calendar'
  },
  icon_prefix: 'k-icon k-i-icon-'
});
